module.exports = __webpack_public_path__ + "img/old-banner-orion.812fe546.jpg";